export const isBrowser = typeof window !== 'undefined';

// TODO: find a better way shim browser environment in server
export const currentWindow: Window = isBrowser ? window : {} as any;
export const currentDocument: Document = isBrowser ? window.document : {} as any;
